<template>
  <div class="main">
    <div class="header">
      <div class="title">
        <span>数据概览</span>
      </div>
      <div class="content">
        <div class="card">
          <img src="@/assets/icon/viewNum.png" height="42px" alt=""/>
          <div class="txt">
            <p class="num">{{ toThousands(subsCensus.allReadCount) }}</p>
            <p class="label">总阅读数</p>
          </div>
        </div>
        <a-divider class="deli" type="vertical" />
        <div class="card">
          <img src="@/assets/icon/txtNum.png" alt=""/>
          <div class="txt">
            <p class="num">{{ toThousands(subsCensus.articleCount) }}</p>
            <p class="label">文章数</p>
          </div>
        </div>
        <a-divider class="deli" type="vertical" />
        <div class="card">
          <img src="@/assets/icon/subsNum.png" height="42px" alt=""/>
          <div class="txt">
            <p class="num">{{ toThousands(subsCensus.userAccessCount) }}</p>
            <p class="label">订阅人数</p>
          </div>
        </div>
      </div>
    </div>
    <div class="deliver"></div>
    <div class="table">
      <div class="title">
        <span>最近操作</span>
      </div>
      <div class="content">
        <table-list
            :dataList="dataList"
            :columns="columns"
            :pagination="pagination"
            :loading="loading"
            tableStatus="workbench"
            @update="updateManuscript"
            @del="delManuscript"
            @getList="articleList"
            @getSubscribeCensus="getSubscribeCensus"
            @handleTableChange="handleTableChange"/>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleList } from '@/api/article'
import { getSubsList, subscribeCensus } from '@/api/subscription'
import moment from "moment";
export default {
name: "index",
  data(){
    return{
      dataTabList:[
        {
          label:'总阅读数',
          value:'2127646',
          icon:'@/assets/icon/viewNum.png'
        },
        {
          label:'总阅读数',
          value:'2127646',
          icon:'@/assets/icon/txtNum.png'
        },
        {
          label:'总阅读数',
          value:'2127646',
          icon:'@/assets/icon/subsNum.png'
        }
      ],
      viewNum:'2127646',
      textNum:'565',
      subsNum:'24',
      columns: [
        {
          title: "标题",
          // align: 'center',
          dataIndex: "title",
          width: 120,
          key: "title",
          scopedSlots: {
            customRender: "titles",
          },
        },
        {
          title: "创建时间",
          align: "center",
          dataIndex: "createAt",
          key: "createAt",
          scopedSlots: {
            customRender: "createAt",
          },
        },
        {
          title: "阅读量",
          align: "center",
          dataIndex: "clickCount",
          key: "clickCount",
        },
        {
          title: "操作",
          width: 220,
          align: "right",
          scopedSlots: {
            customRender: "operation",
          },
        },
      ],
      dataList:[
        
      ],
      pagination:{
        showSizeChanger:true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showQuickJumper:true,
        showTotal: () => `共 ${this.pagination.total} 条`,
        onShowSizeChange: (current, pageSize) => {//设置每页显示数据条数，current表示当前页码，pageSize表示每页展示数据条数
          this.pagination.pageSize=pageSize
        }
      },
      loading:false,
      subsCensus:{},//订阅号统计
    }
  },
  created() {
    this.articleList()
    this.getSubscribeCensus()
  },
  methods:{
    onShowSizeChange(current, pageSize) {
      this.pagination.pageSize = pageSize;
    },
    toThousands(num) {
      var result = '', counter = 0;
      num = (num || 0).toString();
      for (var i = num.length - 1; i >= 0; i--) {
        counter++;
        result = num.charAt(i) + result;
        if (!(counter % 3) && i != 0) { result = ',' + result; }
      }
      return result;
    },
    handleTableChange(pagination, filters, sorter) {
      // console.log(sorter);
      this.page = pagination.current - 1;
      this.articleList(this.page,this.pagination.pageSize);
    },
    //编辑
    updateManuscript(val) {

    },

    //删除
    delManuscript(val) {

    },

    /** 接口*/
    articleList(page=0,pageSize=10){
      this.loading=true
      let subsId=''
      if(sessionStorage.getItem('subsId')){
        subsId=sessionStorage.getItem('subsId')
      }
      var date = new Date();
      date.setDate(date.getDate() - 3);//获取3天前的日期
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      if( month <10){
        month = '0' + month;
      }
      var day = date.getDate();
      if( day < 10){
        day = '0' + day;
      }
      var time = year + "-" + month + "-" + day;
      // console.log(moment(time).valueOf())
      // let date = new Date()
      // let date2=date
      // console.log(moment(date).valueOf(),moment(date2).valueOf())
      let form={
        keyword:'',
        page:page,
        pageSize:pageSize,
        status:-1,
        subscribeSiteId:subsId?subsId:'',
        timeStart:moment(time).valueOf()/1000,
        timeEnd:0,
        uid:''
      }
      getArticleList(form).then(res=>{
        if(res.status){
          this.dataList=res.data
          this.pagination=res.pagination
          this.loading=false
        }
      }).catch(()=>{
        this.$message.error('服务器发送错误!');
        this.loading=false
      })
    },
    getSubsListInfo(){
      let form={
        page:0,
        pageSize: 20,
        user_id:0
      }
      getSubsList(form).then(res=>{

      })
    },
    //获取订阅号统计
    getSubscribeCensus(){
      subscribeCensus().then(res=>{
        if(res.status){
          this.subsCensus=res.data
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
@import "./index";
</style>